module.exports = __webpack_public_path__ + "static/media/140316_FRUITICA_MIXCAFFE_CHOCOHAZELNUT_3in1.10d5703d.jpg";